var _path, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.461 12.3401C1.20249 9.30955 -3.09946 13.6389 3.73953 23.2718C-2.65822 28.2506 0.393573 32.9047 3.73953 36.3682C-3.79925 48.1356 11.461 52.8686 15.8732 46.867C25.3596 60.1798 32.2353 51.3827 33.5222 48.1356C56.3889 54.9429 49.5902 29.9085 47.0899 26.1942C55.5835 10.5002 43.7807 2.92376 33.5222 7.03666C24.9183 -4.76094 8.92393 -0.864489 11.461 12.3401Z",
    fill: "url(#paint0_linear_490_220)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 28,
    rx: 13.5,
    ry: 13,
    fill: "#FF8A00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_490_220",
    x1: 25.9949,
    y1: 0,
    x2: 25.9949,
    y2: 53.5735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/Flower.e290f3ba81c5fd2f1ca4950374766b59.svg";
export { ForwardRef as ReactComponent };